import React, { useEffect, useState } from "react";
import { loadFeedbackUpdates } from "../lib/feedbackNotifications";

export function FeedbackLink({ videoId, compact = false }) {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    let active = true;
    const refresh = async () => {
      if (document.visibilityState === "hidden") return;
      try { const posts = await loadFeedbackUpdates(); if (active) setUnread(posts.length); } catch { /* Don't interrupt watching on a notification failure. */ }
    };
    refresh();
    const timer = window.setInterval(refresh, 60000);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    window.addEventListener("theofast-feedback-updated", refresh);
    window.addEventListener("storage", refresh);
    return () => { active = false; window.clearInterval(timer); window.removeEventListener("focus", refresh); document.removeEventListener("visibilitychange", refresh); window.removeEventListener("theofast-feedback-updated", refresh); window.removeEventListener("storage", refresh); };
  }, []);
  return <a className="feedback-notification-link" href={videoId ? `/feedback?video=${videoId}` : "/feedback"} target="_blank" rel="noreferrer">
    {compact ? "Feedback" : "Issues or feedback?"}
    {unread > 0 && <span className="feedback-unread" role="status" aria-label={`${unread} unread admin ${unread === 1 ? "reply" : "replies"}`}>{unread}</span>}
  </a>;
}
